module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showBtn) ? _c('AddChildrenButton', {
    attrs: {
      "color": "default",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.showBtn = !_vm.showBtn
      }
    }
  }, [_vm._v("Добавить обучающегося")]) : _c('div', {
    staticClass: "addchildren"
  }, [_c('ul', {
    staticClass: "addchildren__list"
  }, _vm._l((_vm.items), function(ref, index) {
    var fullName = ref.fullName;
    var birthday = ref.birthday;
    var id = ref.id;

    return _c('li', {
      key: index,
      staticClass: "addchildren__item"
    }, [_c('Checkbox', {
      model: {
        value: (_vm.checked[id]),
        callback: function($$v) {
          _vm.$set(_vm.checked, id, $$v)
        },
        expression: "checked[id]"
      }
    }), _c('div', {
      staticClass: "addchildren__info"
    }, [_c('span', [_vm._v(_vm._s(fullName))]), _vm._v(", " + _vm._s(birthday))])], 1)
  }), 0), _c('ButtonCanRequest', {
    staticClass: "addchildren__btn",
    attrs: {
      "isPossible": _vm.isChecked,
      "factor": 1.1,
      "possibleColor": "default"
    },
    on: {
      "click": _vm.addChildren
    }
  }, [_vm._v("Добавить")]), _c('AddChildrenButton', {
    staticClass: "addchildren__cancel",
    attrs: {
      "color": "default",
      "size": "small",
      "factor": 1.1,
      "fill": false
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Отмена")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47bea96a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrderAddChildren.vue
// module id = 75f806aa2fbdaeb77d38
// module chunks = 0